/**
 * Indicateurs de fonctionnalités du backoffice.
 *
 * Chaque indicateur est lu depuis une variable d'environnement `REACT_APP_*`
 * au moment de la compilation. Un indicateur absent vaut « désactivé » : il
 * faut écrire explicitement `true` dans le `.env` pour activer une fonctionnalité.
 *
 * Usage dans le JSX : `{SHOPIFY_ENABLED && <BoutonShopify />}`.
 */

/**
 * Convertit une variable d'environnement en booléen.
 * @param {string|undefined} value Valeur brute de `process.env`.
 * @returns {boolean} Vrai uniquement pour « true » (insensible à la casse).
 */
const lireIndicateur = (value) => String(value || '').trim().toLowerCase() === 'true';

/** Intégration Shopify (onglet de configuration, imports, synchronisations). */
export const SHOPIFY_ENABLED = lireIndicateur(process.env.REACT_APP_ENABLE_SHOPIFY);
